<script>
export default {
    name: 'IlluContact',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-contact"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M41.686 10.5H17c-.966 0-1.841.392-2.475 1.025A3.489 3.489 0 0013.5 14v36c0 .966.392 1.841 1.025 2.474A3.489 3.489 0 0017 53.5h30c.966 0 1.841-.392 2.475-1.026A3.489 3.489 0 0050.5 50V19.314a7.5 7.5 0 00-2.197-5.304l-1.313-1.313a7.5 7.5 0 00-5.304-2.197z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
            <path
                d="M44 11v2.5a4 4 0 004 4h2.5"
                :stroke="secondaryColor"
                class="secondary-color"
            />
            <path
                :stroke="secondaryColor"
                class="secondary-color"
                stroke-linecap="round"
                d="M20 39.545l24 .047M20 33.545h24M20 45.591h12M36 27.5h7.667M36 23.5h7.667"
            />
            <path
                :fill="primaryColor"
                class="primary-color"
                d="M20 18h12v10H20z"
            />
        </g>
    </svg>
</template>
